import script from "./PatientSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientSchedule.vue?vue&type=script&setup=true&lang=js"

import "./PatientSchedule.vue?vue&type=style&index=0&id=7fc1afa3&lang=css"

const __exports__ = script;

export default __exports__